import moment from "moment";
export const pickerOptions = {
  //限制选择
  disabledDate(time) {
    return (
      time.getTime() > moment() ||
      time.getTime() < moment().subtract(3, "years")
    );
  },
  //快捷选项
  shortcuts: [
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近三个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近三年",
      onClick(picker) {
        const end = moment();
        const start = moment().subtract(3, "years");
        picker.$emit("pick", [start.toDate(), end.toDate()]);
      }
    }
  ]
};

export const pickerOptionsOfYear = {
  //限制选择
  disabledDate(time) {
    return (
      time.getTime() > moment() ||
      time.getTime() < moment().subtract(3, "years")
    );
  },
  //快捷选项
  shortcuts: [
    {
      text: "最近三年",
      onClick(picker) {
        const end = moment();
        const start = moment().subtract(3, "years");
        picker.$emit("pick", [start.toDate(), end.toDate()]);
      }
    }
  ]
};

// export default pickerOptions;



// WEBPACK FOOTER //
// ./src/utils/datePickerOptions.js